// extracted by mini-css-extract-plugin
export var Container = "explications-module--Container--GXLhB";
export var LineBreak = "explications-module--LineBreak--25fHO";
export var Title1 = "explications-module--Title1--3lcuF";
export var HtmlDiv = "explications-module--HtmlDiv--zAsOB";
export var Button = "explications-module--Button--3TCil";
export var GreyRow = "explications-module--GreyRow--1Q1-V";
export var GreyCol = "explications-module--GreyCol--1O7BZ";
export var GatsbyImage = "explications-module--GatsbyImage--2WOsn";
export var CarouselCaption = "explications-module--CarouselCaption--37fnx";